// Email obfuscation utility to protect from spam harvesters
export const obfuscateEmail = (email) => {
  return email.replace('@', '[at]').replace(/\./g, '[dot]');
};

export const createProtectedEmailLink = (email, displayText = null) => {
  const parts = email.split('@');
  if (parts.length !== 2) return email;
  
  const [user, domain] = parts;
  const obfuscated = `${user}[at]${domain.replace(/\./g, '[dot]')}`;
  
  return {
    href: `mailto:${email}`,
    display: displayText || obfuscated,
    onClick: (e) => {
      e.preventDefault();
      window.location.href = `mailto:${email}`;
    }
  };
};

// Component for protected email display
export const ProtectedEmail = ({ email, displayText, className = "" }) => {
  const handleClick = (e) => {
    e.preventDefault();
    window.location.href = `mailto:${email}`;
  };

  return (
    <a 
      href="#" 
      onClick={handleClick}
      className={className}
      data-email={email.replace('@', '[at]').replace(/\./g, '[dot]')}
    >
      {displayText || email.replace('@', ' [at] ').replace(/\./g, ' [dot] ')}
    </a>
  );
};